<template>
  <div class="proposal">
    <h2>
      {{ proposal.title }} <span>{{ proposal.workArea }}</span>
    </h2>
    <router-link to="/" class="backtoprojects-top"
      >&lt; back to projects</router-link
    >
    <h3>
      {{ proposal.intro }}
    </h3>

    <div class="content-wrapper">
      <div class="col">
        <div class="spacer"></div>
        <p>{{ proposal.details[0] }}</p>
      </div>

      <div class="col">
        <div class="spacer" v-if="proposal.details[1]"></div>
        <p v-if="proposal.details[1]">{{ proposal.details[1] }}</p>

        <div class="spacer"></div>
        <p v-if="proposal.details[2]">{{ proposal.details[2] }}</p>

        <div class="proposal-footer">
          <social-sharing
            :url="'http://blue-temple.com/#/proposal/' + proposal.slug"
            title="Job opening at @bluetemple architecture studio based in Myanmar"
            description=""
            quote=""
            hashtags=""
            twitter-user=""
            inline-template
          >
            <div>
              <network network="facebook">
                <svg
                  class="social-share"
                  height="40.22"
                  viewBox="-21 -21 682.67 682.67"
                  width="40.22"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M604.67 0H35.3A35.32 35.32 0 000 35.33V604.7A35.32 35.32 0 0035.33 640h306.55V392.5h-83.13v-96.88h83.13v-71.29c0-82.67 50.47-127.67 124.22-127.67 35.32 0 65.68 2.63 74.53 3.8v86.42h-50.86c-40.13 0-47.9 19.06-47.9 47.05v61.7h95.94l-12.5 96.87h-83.43V640h162.8c19.5 0 35.32-15.8 35.32-35.31V35.3C640 15.8 624.18 0 604.67 0zm0 0"
                  />
                </svg>
              </network>
              <network network="twitter">
                <svg
                  class="social-share"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    d="M512 97.25a218.84 218.84 0 01-60.48 16.57c21.76-12.99 38.37-33.4 46.18-58.01a209.77 209.77 0 01-66.56 25.4A105.18 105.18 0 00354.46 48c-58.1 0-104.9 47.17-104.9 105 0 8.31.71 16.31 2.44 23.93-87.26-4.26-164.48-46.08-216.35-109.8a105.68 105.68 0 00-14.37 53.06c0 36.35 18.72 68.58 46.62 87.23-16.86-.32-33.4-5.21-47.42-12.92v1.15c0 51 36.38 93.37 84.1 103.13a104.76 104.76 0 01-27.52 3.46c-6.72 0-13.5-.38-19.88-1.8 13.6 41.58 52.2 72.14 98.08 73.13a210.9 210.9 0 01-130.14 44.77c-8.6 0-16.86-.39-25.12-1.44C46.5 446.88 101.6 464 161.02 464c193.16 0 298.76-160 298.76-298.69 0-4.64-.16-9.12-.39-13.57 20.83-14.78 38.34-33.24 52.61-54.5z"
                  />
                </svg>
              </network>
            </div>
          </social-sharing>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ProposalComponent",
  data() {
    return {
      proposal: {
        proposalMetaTitle: "",
        proposalMetaDescription: "",
        details: {
          0: "",
          1: "",
          2: ""
        }
      }
    };
  },
  created() {
    var self = this;

    axios
      .get(
        "https://api.blue-temple.com/work-proposals?slug=" +
          this.$route.params.slug
      )
      .then(function(data) {
        self.proposal = data.data.data[0];
        self.proposal.details = self.proposal.details.split("\r\n\r\n\r\n");
        //
        self.proposalMetaTitle = data.data.data[0].title;
        self.proposalMetaDescription = data.data.data[0].intro;
        //

        for (var x = 0; x < self.proposal.details.length; x++) {
          self.proposal.details[x] = self.proposal.details[x].replace(
            "\r\n\r\n\r\n",
            " "
          );
        }
      })
      .catch(function(error) {
        console.log("Error", error);
      });
  },
  metaInfo() {
    console.log("THIS", this);
    return {
      title: "blue temple | Get Involved",
      meta: [
        {
          name: "description",
          content:
            "We strongly encourage you to reach out to us if you feel that you can contribute to our projects."
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.proposal {
  display: block;
  min-height: 100vh;
  padding: 20px;

  h2 {
    display: block;
    margin-bottom: 20px;
    font-family: "rajdhanibold";
    font-size: 26px;
    font-weight: normal;
    text-transform: uppercase;
    color: $color-light;

    span {
      display: block;
      font-family: "rajdhaniregular";
    }
  }

  h3 {
    display: block;
    font-family: "rajdhaniregular";
    font-size: 18px;
    font-weight: normal;
    color: $color-light;

    + h3 {
      margin-top: 6px;
      font-size: 14px;
    }
  }

  p {
    display: block;
    margin: 20px 0;
    font-family: "rajdhaniregular";
    font-size: 18px;
    font-weight: normal;
    color: $color-light;
    white-space: pre-wrap;
  }

  .spacer {
    display: block;
    width: 100%;
    height: 5px;
    margin: 40px 0 35px;
    background: $color-light;
  }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;

    .col {
      display: block;
      width: 100%;
    }
  }

  &-footer div {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;

    span {
      margin-left: 15px;
    }
  }
}

@media screen and (min-width: 768px) {
  .proposal {
    height: 100vh;
    overflow-y: scroll;

    h3 {
      font-size: 20px;
    }
  }
}

@media screen and (min-width: 1025px) {
  .proposal {
    position: relative;
    height: 100vh;
    padding: 3.1vw;
    overflow-y: scroll;

    h2 {
      margin-top: 8px;
      margin-bottom: 30px;
      font-size: 52px;
      line-height: 48px;
    }

    h3 {
      max-width: 33vw;
      font-size: 24px;
      line-height: 28px;

      + h3 {
        font-size: 18px;
        line-height: 24px;
      }
    }

    .content-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;

      .col {
        display: block;
        width: calc(50% - 30px);
      }
    }

    .backtoprojects-top {
      margin-top: 8px;
    }
  }
}
</style>
